import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({
  children,
  page,
  allowedPages = [],
  accessReady = true,
  fallbackPath = "/access-denied",
}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (!accessReady) {
    return (
      <div className="top-level-page-container" style={{ padding: "32px" }}>
        <p>Загрузка прав доступа...</p>
      </div>
    );
  }
  if (user.role !== "admin") {
    return <Navigate to={fallbackPath} replace />;
  }

  const requiredPages = Array.isArray(page) ? page : (page ? [page] : []);
  if (requiredPages.some((requiredPage) => !allowedPages.includes(requiredPage))) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default AdminRoute;
